const eventHi = {
    event: require('../../lang/hi/event/Event').default,
};

export default eventHi;